import { Layout } from '@components/Layout';
import PermissionGate from '@components/upercut-permissions/PermissionGate';
import SettingsLayout from '@components/Layout/Settings';
import { Route, Routes } from 'react-router-dom';
import SettingsProfilePage from './Profile';

const ProfilePage = () => {
    return (
        <Layout
            breadcrumbs={[
                { label: 'Tableau de bord', href: '/', value: 'dashboard' },
                { label: 'Paramètres', href: '/settings', value: 'settings' },
            ]}
            heading="Paramètres du profil"
        >
            <PermissionGate permission="users:read">
                <SettingsLayout>
                    <Routes>
                        <Route path="/photo" element={<SettingsProfilePage />} />
                        <Route path="/profile" element={<SettingsProfilePage />} />
                        <Route path="/research" element={<SettingsProfilePage />} />
                        <Route path="/skill" element={<SettingsProfilePage />} />
                        <Route path="/formation" element={<SettingsProfilePage />} />
                        <Route path="/experience" element={<SettingsProfilePage />} />
                        <Route path="/certification" element={<SettingsProfilePage />} />
                    </Routes>
                </SettingsLayout>
            </PermissionGate>
        </Layout>
    );
};

export default ProfilePage;
